/* @flow */

export default class CreateMandateRequest {
    isoCompanyId: number;
    sellerCompanyId: number;
    amount: number;
  }
  